const redeemModalState = (root) => root.main?.wallet?.redeemModals.redeemModal;

const redeemBalance = (root) => redeemModalState(root).redeemBalance;

export const redeemModalSelectors = {
  redeemBalance,
};
